import type { SkipAttackReasonType } from '../../../traces/trace-types';

export type { SkipAttackReasonType };

export type BlockedExecutionCopy = {
  title: string;
  badge: string;
  isGuardrailBlocked: boolean;
};

type TranslateFn = (key: string) => string;

export const getBlockedExecutionCopy = ({
  skipAttackReasonType,
  t,
}: {
  skipAttackReasonType?: SkipAttackReasonType;
  t: TranslateFn;
}): BlockedExecutionCopy => {
  const isGuardrailBlocked =
    skipAttackReasonType === 'signal_blocked_by_guardrails';

  const title =
    skipAttackReasonType === 'signal_blocked_by_guardrails'
      ? t('summaryView.blockedByGuardrails')
      : skipAttackReasonType === 'authentication_failure'
        ? t('summaryView.blockedByAuthenticationFailure')
        : skipAttackReasonType === 'provider_content_filter'
          ? t('summaryView.blockedByContentFilter')
          : skipAttackReasonType === 'resume_max_retries_exceeded'
            ? t('summaryView.unableToCompleteExecution')
            : t('summaryView.blockedExecution');

  const badge =
    skipAttackReasonType === 'signal_blocked_by_guardrails'
      ? t('status.guardrail')
      : skipAttackReasonType === 'authentication_failure'
        ? t('summaryView.badgeAuthFailed')
        : skipAttackReasonType === 'provider_content_filter'
          ? t('summaryView.badgeContentFilter')
          : skipAttackReasonType === 'resume_max_retries_exceeded'
            ? t('summaryView.badgeIncomplete')
            : t('summaryView.badgeBlocked');

  return { title, badge, isGuardrailBlocked };
};
